import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/login"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser({ ...data, is_admin: true });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Inloggning misslyckades.";
        setError(msg);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-ink text-white flex flex-col items-center justify-center gap-4 px-6 text-center">
      {error ? (
        <>
          <p className="font-serif text-2xl">{error}</p>
          <a href="/login" className="text-gold-light underline">Tillbaka till inloggning</a>
        </>
      ) : (
        <>
          <div className="h-10 w-10 border-2 border-white/30 border-t-gold rounded-full animate-spin" />
          <p className="overline text-white/60">Loggar in...</p>
        </>
      )}
    </div>
  );
};

export default AuthCallback;
